import { DFB_CATS, transformCustomStatValue } from "./PlayerStats";

export class PlayerStatsComparison {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "PlayerStatsComparison";
    this.cb_scene = "Player Stats Comparison";
    this.data = [];
  }

  buildPlayerFields({ prefix, player, team, game }) {
    const kit = prefix === "Home" ? game?.home_team_kit : game?.away_team_kit;
    this.data.push({
      name: `${prefix} First Name`,
      value: { text: player?.first_name ?? player?.opta_first_name ?? "" },
    });
    this.data.push({
      name: `${prefix} Last Name`,
      value: { text: player?.last_name ?? player?.opta_last_name ?? "" },
    });
    this.data.push({
      name: `${prefix} Full Name`,
      value: {
        text:
          (player?.first_name ?? player?.opta_first_name ?? "") +
          " " +
          (player?.last_name ?? player?.opta_last_name ?? ""),
      },
    });
    this.data.push({
      name: `${prefix} Shirt Number`,
      value: { text: player?.shirt_number ?? player?.opta_shirt_number ?? "" },
    });
    this.data.push({
      name: `${prefix} Image`,
      value: { image: "${user}" + (player?.image || "") },
    });
    this.data.push({
      name: `${prefix} Team Name`,
      value: { text: team?.name || "" },
    });
    this.data.push({
      name: `${prefix} Team Badge`,
      value: { image: "${user}" + (team?.variables?.badge || "") },
    });
    this.data.push({
      name: `${prefix} Team Kit BG Colour`,
      value: { colour: team?.variables?.[kit + "_kit_bg"] || "" },
    });
    this.data.push({
      name: `${prefix} Team Kit Text Colour`,
      value: { colour: team?.variables?.[kit + "_kit_text"] || "" },
    });
  }

  buildStatFields({ prefix, statsEntry }) {
    DFB_CATS.forEach((cat) => {
      this.data.push({
        name: `${prefix} ${cat.title}`,
        value: { text: cat?.calc({ stats: statsEntry?.stats }) || 0 },
      });
    });
  }

  preview({ options }) {
    if (options.customStatTitle) {
      this.buildCustomStat({ options });
      return;
    }
    this.onAir = false;
    this.data = [];
    this.scene = this.cb_scene;
    const { homePlayer, awayPlayer, game } = options;

    this.data.push({
      name: "Competition",
      value: { text: game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + (game?.competition?.badge || "") },
    });

    this.buildPlayerFields({
      prefix: "Home",
      player: homePlayer,
      team: game?.home_team,
      game,
    });
    this.buildPlayerFields({
      prefix: "Away",
      player: awayPlayer,
      team: game?.away_team,
      game,
    });

    const homeStats = game?.sportec_player_stats?.home?.find(
      (p) => p?.player === homePlayer?.dfb_ID,
    );
    const awayStats = game?.sportec_player_stats?.away?.find(
      (p) => p?.player === awayPlayer?.dfb_ID,
    );

    this.buildStatFields({ prefix: "Home", statsEntry: homeStats });
    this.buildStatFields({ prefix: "Away", statsEntry: awayStats });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  buildCustomStat({ options }) {
    this.onAir = false;
    this.data = [];
    const {
      homePlayer,
      awayPlayer,
      game,
      customStatTitle,
      homeCustomStatValue,
      awayCustomStatValue,
      customStatType,
      period,
    } = options;
    
    if (options.full_frame) {
      this.scene = this.ff_scene;
    } else {
      this.scene = this.cb_scene;
    }

    this.data.push({
      name: "Competition",
      value: { text: game?.competition?.name || "" },
    });
    this.data.push({
      name: "Competition Colour",
      value: { colour: game?.competition?.colour || "" },
    });
    this.data.push({
      name: "Competition Badge",
      value: { image: "${user}" + (game?.competition?.badge || "") },
    });

    this.buildPlayerFields({
      prefix: "Home",
      player: homePlayer,
      team: game?.home_team,
      game,
    });
    this.buildPlayerFields({
      prefix: "Away",
      player: awayPlayer,
      team: game?.away_team,
      game,
    });

    this.data.push({
      name: "Custom Stat Title",
      value: { text: customStatTitle || "" },
    });
    this.data.push({
      name: "Home Custom Stat",
      value: {
        text: transformCustomStatValue(homeCustomStatValue, customStatType),
      },
    });
    this.data.push({
      name: "Away Custom Stat",
      value: {
        text: transformCustomStatValue(awayCustomStatValue, customStatType),
      },
    });
    this.data.push({
      name: "Stat Type",
      value: {
        text:
          game?.dfb_ID !== null ? (customStatType ?? 0) : (customStatType ?? ""),
      },
    });

    this.sendPreview(this.scene, 500, this.data, "IN");
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate(this.scene, this.data);
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff(this.scene, []);
  }
}
